export default {
  title: 'Serviciul de rezervări al companiei este dezactivat',
  description: 'Serviciul de rezervări este momentan inactiv pentru această companie. Îl puteți activa din Servicii.',
  button: {
    settings: 'Mergeți la Setări',
  },
};
